import React from 'react'
import { BLOCKS } from '@contentful/rich-text-types'
import { documentToReactComponents } from '@contentful/rich-text-react-renderer'
import './faq.scss'
import FaqCard from '../../atoms/faq-card/faq-card'
import { pushDataLayerEvent } from '../../../utils/metricManagementUtil'
import { dataLayerUserInfo } from '../../../utils/userInfo'

const Faq = ({ content, ...props }) => {
	const options = {
		renderNode: {
			[BLOCKS.HEADING_3]: (node, next) => (
				<h3 className='f-faq-title'>{next}</h3>
			),
			[BLOCKS.PARAGRAPH]: (node, next) => (
				<p className='f-p f-faq-text'>{next}</p>
			),
		},
	}
	const [activeCard, setAciveCard] = React.useState(0)

	const handleChange = index => {
		activeCard === index ? setAciveCard(-1) : setAciveCard(index)
	}

	const userInfo=dataLayerUserInfo()
	const dataLayerPreguntasFrecuentes = (preguntasFrecuentesLabel) => {      
			let location=''
			if (typeof window !== 'undefined') {
					location= window.location.href
			}
			pushDataLayerEvent({event: 'Interacciones - Preguntas',
			category: 'preguntas_frecuentes',
			action: 'click',
			label: preguntasFrecuentesLabel,
			location: location,
			user_data: userInfo.user_data? userInfo.user_data: '',
			log_status: userInfo.log_status,})
	}

	return (
		<>
			<div className='f-faq-wrapper'>
				{content.descripcionGeneral && (
					<div className='f-faq-header-container'>
						<div className='f-faq-header-content'>
							{documentToReactComponents(
								content.descripcionGeneral.json,
								options
							)}
						</div>
					</div>
				)}
				<div className='f-faqcards-container'>
					{content.preguntasFrecuentes.map((question, index) => {
						const { preguntasFrecuentes, titulo } = question
						return (
							<FaqCard
								key={index}
								info={preguntasFrecuentes.json}
								title={titulo}
								isActiveCard={activeCard === index}
								setActiveCard={() => {
									props.dataLayer &&
										props.dataLayer({
											question,
											action: activeCard === index ? 'contraer' : 'desplegar',
										})
									dataLayerPreguntasFrecuentes(titulo)
									handleChange(index)
								}}
							/>
						)
					})}
				</div>
			</div>
		</>
	)
}
export default Faq
